export const ACCESSORY_PRODUCT_PRESET_SUBTYPE_DESCRIPTIONS: Record<
  string,
  string
> = {
  'shoe/sneaker': 'A closed athletic shoe built on a flat, flexible sole.',
  'shoe/running-shoe':
    'A secure lace-up shoe with cushioning from heel to toe.',
  'shoe/loafer': 'A low slip-on shoe with an exposed ankle and no laces.',
  'shoe/boot': 'An enclosed shoe with an upper extending above the ankle.',
  'shoe/sandal': 'An open shoe secured to the foot by straps over a footbed.',
  'shoe/mule': 'A backless shoe with a closed or strapped forefoot.',
  'shoe/pump': 'A low-cut closed shoe supported by a raised heel.',
  'shoe/oxford':
    'A low formal shoe with closed lacing quarters over the instep.',
  'shoe/derby': 'A low formal shoe with open lacing quarters over the instep.',
  'shoe/slip-on': 'A closed laceless shoe shaped for easy entry.',
  'shoe/ballet-flat': 'A very low-cut shoe built on a thin, flat sole.',
  'shoe/mary-jane':
    'A low closed-toe shoe secured by a strap across the instep.',
  'shoe/espadrille':
    'A shoe with a rope-wrapped sole edge and an open or closed upper.',
  'shoe/clog':
    'A rigid-soled shoe with a roomy closed toe and an open or low back.',
  'shoe/slipper': 'A soft, low indoor shoe with a lightweight sole.',

  'earrings/stud':
    'An earring that sits directly on the lobe with a straight post closure.',
  'earrings/hoop':
    'A circular earring with an opening that passes through the lobe.',
  'earrings/huggie':
    'A small hinged hoop that fits closely around the earlobe.',
  'earrings/drop':
    'An earring with one fixed element suspended vertically below the lobe.',
  'earrings/dangle':
    'An earring with multiple articulated elements that move freely below the lobe.',
  'earrings/chandelier': 'A wide earring composed of tiered, branching drops.',
  'earrings/ear-cuff':
    'An open band that wraps the ear edge without requiring a lobe post.',
  'earrings/threader':
    'A fine chain threaded through the piercing with drops on both sides.',
  'earrings/ear-climber':
    'An elongated earring anchored at the lobe and rising along the ear.',
  'earrings/jacket':
    'A front stud paired with a separate ornament positioned behind the lobe.',
  'earrings/teardrop':
    'A hanging earring that tapers at the top and rounds toward the bottom.',
  'earrings/clip-on':
    'A non-pierced earring held against the lobe by a clip closure.',

  'tote-bag/open-top': 'A two-handled tote with an open, unfastened top.',
  'tote-bag/zip-top':
    'A two-handled tote secured by a zipper across the full top opening.',
  'tote-bag/shopper':
    'A wide rectangular tote with long handles for shoulder carry.',
  'tote-bag/market': 'A broad open tote supported by reinforced carry handles.',
  'tote-bag/boat': 'A tote with a wide flat base and sides that taper upward.',
  'tote-bag/beach':
    'An oversized open tote with a broad, easy-access carry opening.',
  'tote-bag/structured':
    'A self-supporting tote with a defined base and firm side panels.',
  'tote-bag/bucket':
    'An upright cylindrical tote built on a round or oval base.',
  'tote-bag/foldable':
    'A lightweight tote with a collapsible body and integrated handles.',
  'tote-bag/utility':
    'An open tote organized with functional pockets on the exterior.',

  'shoulder-bag/hobo':
    'A slouchy crescent-shaped bag carried from one shoulder strap.',
  'shoulder-bag/baguette':
    'A short horizontal bag with a compact shoulder strap.',
  'shoulder-bag/saddle':
    'A curved-bottom bag with a front flap and a long shoulder strap.',
  'shoulder-bag/crescent':
    'A crescent-shaped bag with a strap following its curved upper edge.',
  'shoulder-bag/flap':
    'A shoulder bag closed by a flap covering the front opening.',
  'shoulder-bag/structured':
    'A self-supporting shoulder bag with a defined base and gussets.',
  'shoulder-bag/pouch':
    'A compact soft bag with a gathered or zipped top opening.',
  'shoulder-bag/bucket':
    'An upright round-base bag finished with a drawstring-style opening.',
  'shoulder-bag/camera': 'A compact box-shaped shoulder bag with a top zipper.',
  'shoulder-bag/messenger':
    'A wide rectangular shoulder bag covered by a large front flap.',
  'shoulder-bag/box':
    'A rigid geometric shoulder bag with clearly defined hard edges.',
  'shoulder-bag/mini':
    'A small shoulder bag with compact body and strap proportions.',

  'backpack/daypack':
    'A compact everyday backpack with one main compartment and two shoulder straps.',
  'backpack/laptop':
    'A rectangular protected backpack with a dedicated compartment for a device.',
  'backpack/hiking':
    'A tall load-bearing backpack supported by a structured harness system.',
  'backpack/travel':
    'A large carry-on backpack with wide access to the packing compartment.',
  'backpack/school':
    'A medium backpack with a main compartment and front organizer pocket.',
  'backpack/roll-top':
    'A backpack with an extended folding top secured by a buckle.',
  'backpack/drawstring':
    'A soft sack-like backpack closed at the top by cords.',
  'backpack/tactical':
    'A segmented utility backpack with rows of external webbing.',
  'backpack/sling':
    'A compact asymmetric backpack carried from one diagonal strap.',
  'backpack/convertible':
    'A backpack with shoulder straps and alternate handles for another carry mode.',
  'backpack/hydration':
    'A slim close-fitting backpack with routing for a drinking tube.',
  'backpack/camera':
    'A structured padded backpack with divided access for camera equipment.',

  'glasses/round':
    'Glasses with circular lens rims and a balanced curved front.',
  'glasses/square':
    'Glasses with equal-height angular lens rims and defined corners.',
  'glasses/rectangle':
    'Glasses with wide shallow lens rims and straight frame edges.',
  'glasses/oval':
    'Glasses with elongated curved rims and a soft, narrow front.',
  'glasses/cat-eye':
    'Glasses with tapered inner rims and outer corners that sweep upward.',
  'glasses/aviator':
    'Glasses with teardrop-shaped lens rims joined by a double bridge.',
  'glasses/wayfarer':
    'Glasses with thick angled fronts framing trapezoidal lenses.',
  'glasses/browline':
    'Glasses with a strong upper frame and a finer lower rim.',
  'glasses/geometric':
    'Glasses with multi-sided lens rims and sharply faceted frame edges.',
  'glasses/rimless':
    'Glasses with bare lens edges mounted directly to the bridge.',
  'glasses/half-rim':
    'Glasses with partial rims that leave one lens edge exposed.',
  'glasses/pantos':
    'Glasses with rounded lens rims and a gently flattened upper curve.',

  'wrist-watch/dress':
    'A refined watch with a slim case and a clean, restrained dial.',
  'wrist-watch/dive':
    'A watch with a rotating timing bezel and highly visible dial markers.',
  'wrist-watch/field':
    'A durable compact watch with a simple, highly legible dial.',
  'wrist-watch/pilot':
    'A watch with a large legible dial and a prominent crown.',
  'wrist-watch/chronograph':
    'A watch with multiple timing subdials and pushers on the case.',
  'wrist-watch/racing':
    'A timing-focused watch with a tachymeter-style scale around the dial.',
  'wrist-watch/gmt':
    'A watch with an additional timezone hand and a 24-hour scale.',
  'wrist-watch/sports':
    'A robust watch designed around a clear, high-legibility dial.',
  'wrist-watch/digital':
    'A button-controlled watch with a numeric display window.',
  'wrist-watch/skeleton':
    'A watch with an openworked dial revealing its movement structure.',
  'wrist-watch/moonphase':
    'A calendar-focused watch with an aperture displaying the moon cycle.',
  'wrist-watch/smartwatch': 'A sensor-backed watch with a full digital screen.',
};
